import React from "react";
import { Text } from "../../atoms/Text/Text";
import classNames from "classnames";

import { FriendTabs } from "../../services/Friend/FriendService";

import styles from "./FriendContainer.css";

type ChallengesTabMenuProps = {
  tabId: FriendTabs;
  receivedNotifications: number;
  sendNotifications: number;
  onTabSelect?: (tab: FriendTabs, gameId?: number) => void;
};

export class RenderChallengesTabMenu extends React.Component<ChallengesTabMenuProps> {
  render() {
    const { tabId, onTabSelect, receivedNotifications, sendNotifications } =
      this.props;
    return (
      <ChallengeTabMenu>
        <ChallengeTabMenuItem
          onClick={() => onTabSelect(FriendTabs.ViewSendChallenges)}
          active={tabId === FriendTabs.ViewSendChallenges}
        >
          Send
          {sendNotifications > 0 && (
            <NotificationBadge>{sendNotifications}</NotificationBadge>
          )}
        </ChallengeTabMenuItem>
        <ChallengeTabMenuItem
          onClick={() => onTabSelect(FriendTabs.ViewReceivedChallenges)}
          active={tabId === FriendTabs.ViewReceivedChallenges}
        >
          Received
          {receivedNotifications > 0 && (
            <NotificationBadge>{receivedNotifications}</NotificationBadge>
          )}
        </ChallengeTabMenuItem>
      </ChallengeTabMenu>
    );
  }
}
const NotificationBadge = (props: any) => (
  <span className={styles.notification_badge} {...props} />
);
const ChallengeTabMenu = (props: any) => (
  <div className={styles.challenge_tabs_menu} {...props} />
);
const ChallengeTabMenuItem = ({ active, children, ...props }: any) => (
  <div {...props}>
    <Text className={classNames(styles.tab_item, { [styles.active]: active })}>
      {children}
    </Text>
  </div>
);
